import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M8,17.25A8.23,8.23,0,0,1,20.13,10a.25.25,0,0,0,.37-.22V6a2,2,0,0,0-1.6-2,.5.5,0,0,1-.4-.49V2a2,2,0,0,0-2-2H4A3,3,0,0,0,1,3V21a3,3,0,0,0,3,3h6.79a.25.25,0,0,0,.23-.16.25.25,0,0,0-.07-.28A8.24,8.24,0,0,1,8,17.25ZM3,3A1,1,0,0,1,4,2H16.25a.25.25,0,0,1,.25.25v1.5a.25.25,0,0,1-.25.25H4A1,1,0,0,1,3,3Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M16.25,24A6.75,6.75,0,1,0,9.5,17.25,6.76,6.76,0,0,0,16.25,24Zm0-2.75a1,1,0,0,1-1-1V18a.5.5,0,0,0-.5-.5H14a.46.46,0,0,1-.37-.73l2.26-3.09a.49.49,0,0,1,.37-.18.45.45,0,0,1,.36.18l2.27,3.09a.46.46,0,0,1,0,.48.45.45,0,0,1-.4.25h-.74a.5.5,0,0,0-.5.5v2.25A1,1,0,0,1,16.25,21.25Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }